import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloLink,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";

// ── Single source of truth for the environment ──────────────
// Change via REACT_APP_API_BASE_URL in .env.development / .env.uat / .env.production
// export const API_BASE_URL =
//   process.env.REACT_APP_API_BASE_URL || "https://matrix.mcb.co.ke";
export const API_BASE_URL ="https://api.sheriapro.sababisha.com";
//export const API_BASE_URL ="https://matrix.mcb.co.ke";

let hasRefreshed = false;

const onErrorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, location, path }) => {
      alert(`Graphql error ${message}`);
    });
  }
});


const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("Token not found in localStorage");
    return {};
  }

  const formattedToken = `Bearer ${token.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
  };
};

const authMiddleware = new ApolloLink((operation, forward) => {
  const headers = getAuthHeaders();
  if (headers.Authorization) {
    operation.setContext({
      headers: {
        ...headers,
      },
    });
  } else {
    console.warn("Authorization header is missing");
  }

  return forward(operation);
});

export const createUsersClient = () => {
  const userManagementHttpLink = new HttpLink({
    uri: `${API_BASE_URL}/usermanagement`,
  });
  const userHttpLinkWithAuth = authMiddleware.concat(userManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(userHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};

export const createRoleClient = () => {
  const roleManagementHttpLink = new HttpLink({
    uri: `${API_BASE_URL}/rolemanagement`,
  });
  const roleHttpLinkWithAuth = authMiddleware.concat(roleManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(roleHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};

export const createClientManagementClient = () => {
  const clientManagementHttpLink = new HttpLink({
    uri: `${API_BASE_URL}/clientmanagement`,
  });
  const clientHttpLinkWithAuth = authMiddleware.concat(clientManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(clientHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};

export const createSetupClient = () => {
  const setupManagementHttpLink = new HttpLink({
    uri: `${API_BASE_URL}/setupmanagement`,
  });
  const setupHttpLinkWithAuth = authMiddleware.concat(setupManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(setupHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};

export const loginUrl = {
  login: `${API_BASE_URL}/login`,
};

export const roleManagemenUrl = {
  uri: `${API_BASE_URL}/rolemanagement`,
};

export const caseManagementUrl = {
  uri: `${API_BASE_URL}/casemanagement`,
};

export const documentManagementUrl = {
  uri: `${API_BASE_URL}/documentmanagement`,
  baseFilePath: `${API_BASE_URL}/documentmanagement/ReadDocument?`,
};

export const setupManagement = {
  uri: `${API_BASE_URL}/setupmanagement`,
};

export const clientManagementUrl = {
  uri: `${API_BASE_URL}/clientmanagement`,
};

export const userManagementUrl = {
  uri: `${API_BASE_URL}/usermanagement`,
};

export const AccountsandFinanceurl = {
  uri: `${API_BASE_URL}/accountsmanagement`,
};

export const documentUploadUrl = {
  uri: `${API_BASE_URL}/documentmanagement/UploadCaseDocument`,
  uri2: `${API_BASE_URL}/documentmanagement`,
  uri3: `${API_BASE_URL}`,
  uri4: "https://api.sheriapro.sababisha.com",
};

export const companyManagementUrl = {
  uri: `${API_BASE_URL}/companymanagement`,
  upload_logo_uri: `${API_BASE_URL}/UploadLogo`,
};

export const smsservice = {
  uri: `${API_BASE_URL}/smsservice`,
};

export const accountsmanagement = {
  uri: `${API_BASE_URL}/accountsmanagement`,
};

export const setupManagementUrl = {
  uri: `${API_BASE_URL}/setupmanagement`,
};

export const notificationservice = {
  uri: `${API_BASE_URL}/notificationservice`,
};

export const ForgetPasswordApiService = {
  uri: `${API_BASE_URL}/forgotpassword`,
};

export const deleteDocumentService = {
  uri: `${API_BASE_URL}/documentmanagement/DeleteCaseFile`,
};

export const MCBSwitchService = {
  uri: `${API_BASE_URL}/mcbswitch`,
};

export const emailService = {
  uri: `${API_BASE_URL}/emailservice`,
};

export const HRService = {
  uri: `${API_BASE_URL}/HRService`,
};

export const uploadCaseService = {
  uri: `${API_BASE_URL}/uploadCases`,
};

export const uploadCaseForClientService = {
  uri: `${API_BASE_URL}/uploadCasesForClient`,
};

export const uploadIndividualClients = {
  uri: `${API_BASE_URL}/uploadIndividualClients`,
};

export const uploadCorporateClients = {
  uri: `${API_BASE_URL}/uploadCorporateClients`,
};

export const downloadCaseForClientService = {
  uri: `${API_BASE_URL}/DownloadCasesForClientTemplate`,
};

export const downloadCaseService = {
  uri: `${API_BASE_URL}/DownloadCaseTemplate`,
};

export const downloadIndividualClients = {
  uri: `${API_BASE_URL}/DownloadIndividualTemplate`,
};

export const downloadCorporateClients = {
  uri: `${API_BASE_URL}/DownloadCorporateTemplate`,
};

// Report engine is a separate standalone service — not behind the gateway,
// so it keeps its own base URL rather than using API_BASE_URL.
export const reportManagementUrl = {
  generate_report_uri: "https://finsights.mcb.co.ke/sheriaproengine/generateReport",
};